import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Dispatch, SetStateAction } from "react"
interface BusinessStageProps {
  setBusinessStateSelectedOption: Dispatch<
    SetStateAction<businessType | undefined>
  >
  businessStateSelectedOption: businessType | undefined
}
export type businessType = {
  title: string
  svg: object
  subTitle: string
}
export const BusinessStage = ({
  setBusinessStateSelectedOption,
  businessStateSelectedOption,
}: BusinessStageProps) => {
  const data = [
    {
      title: "What stage is your business in?",
      options: [
        {
          svg: <StaticImage src="../../svg-icons/bulb-icon.svg" alt="bulb" />,
          title: "Idea",
          subTitle: "Planning your first step",
        },
        {
          svg: <StaticImage src="../../svg-icons/plan-icon.svg" alt="bulb" />,
          title: "Launch",
          subTitle: "From Vision to Velocity",
        },
        {
          svg: (
            <StaticImage src="../../svg-icons/arrow-pol-icon.svg" alt="bulb" />
          ),
          title: "Expansion",
          subTitle: "Scaling New Heights",
        },
        {
          svg: (
            <StaticImage src="../../svg-icons/building-icon.svg" alt="bulb" />
          ),
          title: "Established",
          subTitle: "Foundation of Success",
        },
      ],
    },
  ]
  return (
    <>
      {data.map((faq, index) => (
        <div key={index} className="mt-10 pt-10 container mx-auto">
          <div className="flex gap-1 justify-center">
            <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
              {faq.title}
            </h2>
            <p className="pt-2 text-black"> (Optional)</p>
          </div>
          <div className="flex lg:flex-nowrap flex-wrap gap-3 lg:justify-start mx-3 items-center mt-10">
            {faq.options?.map((option, i) => (
              <div key={i} className="lg:p-2 p-1 lg:w-1/4 w-[48%]">
                <div
                  className={`bg-real-time-options w-full  hover:border-[#7B68EC] cursor-pointer flex flex-col text-center items-center py-10 rounded-2xl justify-center ${
                    businessStateSelectedOption?.title === option?.title
                      ? "border-none bg-input"
                      : ""
                  }`}
                  onClick={() =>
                    setBusinessStateSelectedOption(
                      businessStateSelectedOption?.title === option?.title
                        ? undefined
                        : option
                    )
                  }
                >
                  {option.svg}
                  <p
                    className={` py-3 font-semibold ${
                      businessStateSelectedOption?.title === option?.title
                        ? "text-[#7B68EC]"
                        : "text-black"
                    }`}
                  >
                    {option.title}
                  </p>
                  <p className="text-gray text-sm">{option.subTitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  )
}
